import { useTaskLogsQuery } from '../../api/queries/taskLogs';
import { Logs } from '../Logs';

export interface TaskLogsProps {
  name: string;
  index: number;
  taskId: string;
}

export function TaskLogs(props: TaskLogsProps) {
  const logsQuery = useTaskLogsQuery(props.taskId);

  return (
    <Logs
      logs={logsQuery.data?.logs}
      loading={logsQuery.isLoading}
      fileName={`${props.name}_${props.index}_logs.txt`}
    />
  );
}
